import React, { Component } from 'react';
import "LIBRARY/Components/Invoices/importInvoice.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import CSVReader from 'react-csv-reader'
import { CSVLink } from 'react-csv';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import { toast } from 'react-toastify';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';

const papaparseOptions = {}

class ImportInvoice extends Component {
    constructor(props) {
        super(props)
        this.tableObject = {};
        this.state = {
            importInvoiceModal: false,
            tabs: [
                { name: "Choose CSV File" },
                { name: "Start Import" }
            ],
            currentTab: 0,

            csvData: [],
            postInvoiceDetailsArray: [],
            postInvoiceHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                errors: [],
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
                verificationHistory: {}
            },

            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },
            verifiedData: [],
            selectedCSVFiles: {},

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},
            fullScreen: false,

            errorMessageObjArray: [],
            preRequisiteFileName: 'Prerequisite Data.csv',


            //PreRequisite data
            preRequisiteCSVDataForFaculty: [
                { poName: '' },
            ],

            preRequisiteData: [],

            loadingPurchaseOrderData: false,

            preRequisiteCSVHeadersForFaculty: [
                { label: "Purchase Order Name", key: "poName" },
            ],

            preRequisiteHeaders: [],
            verifyImportInvoiceResult: '',  // set response of import invoice 
            loadingImportInvoiceProcess: false,
            // VARIABLES FOR ADD INVOICE
            assetCategoryDetails: {
                0: {
                    'categoryId': '',
                    'index': 0,
                    'description': '',
                    'amount': '',
                    'taxValue': ''
                }
            },
            linkTo: 'Library',
            taxType: 'inclusive',
            vendorId: '',
            poId: '',

            isPurchaseOrderFetching: false,
            poData: [],
            isImportButtonDisabled: false
        }
    }

    componentDidMount() {
        // METHOD TO GET PO LIST
        this.getPOList();

        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty
        let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForFaculty

        this.setState({
            preRequisiteData: preRequisiteData,
            preRequisiteHeaders: preRequisiteHeaders,
        })

    }

    // METHOD TO GET VENDOR (purchase order) DETAILS
    getPOList = async () => {
        this.setState({
            isPurchaseOrderFetching: true,
            poData: []
        });

        let requestData = {
            "instituteId": config.institute_id,
            "page_index": 1,
            "limit": 1000
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'accounting_getPurchaseOrder',
            requestData,
            '/api/accounting/accounting.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getPOList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({
                    isPurchaseOrderFetching: false
                });
                let apiResult = jsonResponse.APIResult.data;

                let preRequisiteData = this.state.preRequisiteData;

                // For purchaseOrderNameList
                if (Object.values(apiResult).length > 0) {
                    Object.keys(apiResult).map((Id, index) => {

                        let poSeriesNo = apiResult[Id]
                        // Concatenating seriesTitle and seriesCounter
                        let concatenatedPoName = poSeriesNo.seriesTitle + poSeriesNo.seriesCounter;

                        if (poSeriesNo != undefined) {
                            if (preRequisiteData[index] != undefined) {
                                preRequisiteData[index].poName = concatenatedPoName
                            }
                            else {
                                preRequisiteData.push({ poName: concatenatedPoName })
                            }
                        }
                    })
                }


                this.setState({
                    poData: apiResult,
                    totalCount: jsonResponse.APIResult.Total,
                    preRequisiteData
                });
            }
            else {
                this.setState({
                    isPurchaseOrderFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while fetching vendor data. Please try again later.'
                });
            }
        }
    }

    // Import INVOICE Modal Start From Here
    openImportInvoiceModal = () => {

        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['invoice'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {

            this.setState({
                importInvoiceModal: true,
                isImportButtonDisabled: false
            })

        } else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }

    }

    closeImportInvoiceModal = () => {
        this.setState({
            importInvoiceModal: false,
            currentTab: 0,

            csvData: [],
            postInvoiceDetailsArray: [],
            postInvoiceHeadersArray: [],
            selectedCSVFiles: {},
            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            verifiedData: [],
            loadingVerificationProcess: false,
            verificationProgress: {
                completed: 0,
                failed: 0,
                total: 0,
                pending: 0
            },
            verificationPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },

            loadingImportProcess: false,
            importProgressSummary: { completed: 0, failed: 0, total: 0, pending: 0 },
            importPointer: {
                loading: false,
                rowindex: 0,
                status: 'pending'
            },
            verifiedData: [],
            selectedCSVFiles: {},

            importProgress: [
                { name: "Verification", completed: false },
                { name: "Import", completed: false }
            ],
            currentProgress: 0,

            // Bug Console
            errorLogs: [],
            currentPointer: 0,
            currentErrorObject: {},

        });
        // document.getElementById("react-csv-reader-input").value = '';
        // Clear the file input field using document.getElementById
        const fileInput = document.getElementById("react-csv-reader-input");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        }
    }

    // OPEN FILE
    openFileInput = () => {
        document.getElementById("react-csv-reader-input").click();
    }

    // REMOVE SELECTED CSV FILE
    removeCSVFile = () => {
        this.setState({
            selectedCSVFiles: {},
            csvData: [],
            postInvoiceDetailsArray: [],
            postInvoiceHeadersArray: [],

            validations: {
                headersErrors: [],
                dataErrors: {},
                isDataValid: false,
                isHeadersValid: false,
                isVerified: false,
            },
            selectedCSVFiles: {},
            verifiedData: [],
        });
        // document.getElementById("react-csv-reader-input").value = '';
        // Clear the file input field using document.getElementById
        const fileInput = document.getElementById("react-csv-reader-input");
        if (fileInput) {
            fileInput.value = ''; // Reset the input value
        }
    }

    // Import INVOICE Modal
    importInvoiceModal = () => {
        let resultFailedData = this.state.postInvoiceDetailsArray.filter((item) => item.importStatus == 'failed')
        let resultSuccessData = this.state.postInvoiceDetailsArray.filter((item) => item.importStatus == 'success')
        let resultPendingData = this.state.postInvoiceDetailsArray.filter((item) => item.importStatus == 'pending')

        return (
            <>
                <div className={this.state.importInvoiceModal ? 'modal fade show' : 'modal'} style={{ display: this.state.importInvoiceModal ? "block" : 'none', visibility: this.state.importInvoiceModal ? 'visible' : 'hidden' }}>
                    <div class="modal-dialog modal-lg--userdetails modal-dialog-centered" style={{ maxWidth: this.state.fullScreen ? '100vw' : '60vw', margin: this.state.fullScreen ? "0px auto" : "auto" }}>
                        <div class="modal-content modal-dialog-scrollable modal_content">
                            <div class="modal-header modal_header">
                                <h5 class="modal-title" style={{ textAlign: 'left' }} id="exampleModalLabel">Import Invoice Details</h5>
                                {this.state.loadingImportInvoiceProcess || this.state.loadingImportProcess ?
                                    null :
                                    <span style={{ cursor: "pointer" }} onClick={() => {
                                        this.closeImportInvoiceModal()
                                    }}>
                                        <FontAwesomeIcon icon={['fas', 'times']} size={'md'} />
                                    </span>
                                }
                            </div>
                            <div class="modal-body" style={{ maxHeight: this.state.fullScreen ? '100vh' : "80vh", height: this.state.fullScreen ? '100vh' : '80vh' }}>
                                <div className="">
                                    <div className="row">
                                        <div className="col">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="import-header">
                                                    {
                                                        this.state.tabs.map((item, index) => {
                                                            return (
                                                                <div className="tab-wrapper"><span className={this.state.currentTab == index ? "circle-tab" : "circle-tab-muted"}>{index + 1}</span><p className={this.state.currentTab == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p></div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                                <button style={{ all: 'unset', cursor: "pointer" }} onClick={() => {
                                                    this.setState({
                                                        fullScreen: !this.state.fullScreen
                                                    })
                                                }}>
                                                    {
                                                        this.state.fullScreen ?
                                                            (
                                                                <span>
                                                                    <span style={{ border: '2px solid #000', padding: '2px' }} title={"Compress Edit Mode"}><FontAwesomeIcon icon={['fas', 'compress-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                                </span>
                                                            ) :
                                                            (
                                                                <span>
                                                                    <span style={{ border: '2px solid #000', padding: '2px' }} title={"Expand Edit Mode"}><FontAwesomeIcon icon={['fas', 'expand-alt']} size={'1x'}></FontAwesomeIcon></span>
                                                                </span>
                                                            )
                                                    }
                                                </button>
                                            </div>

                                            {
                                                this.state.currentTab == 0 && this.chooseFileComponent()
                                            }
                                            {
                                                this.state.currentTab == 1 && this.importCSVFileComponent()
                                            }

                                            <div className="import-footer">
                                                {
                                                    this.state.currentTab == 1 &&

                                                    <div style={{ width: '100%', margin: '0px 10px 0 0' }}>

                                                        {
                                                            <div className="d-flex align-items-center flex-wrap" style={{ display: this.state.loadingImportProcess ? '' : 'none !important' }}>
                                                                {
                                                                    <>
                                                                        <ProgressBar bgcolor={"#6a1b9a"} completed={this.state.importProgressSummary['completed']} failed={this.state.importProgressSummary['failed']} total={this.state.importProgressSummary['total']} pending={this.state.importProgressSummary['pending']} />
                                                                        <p className="mb-0 font-weight-bold" style={{ fontSize: 14 }}>Import Progress: {(this.state.importProgressSummary['total'] - this.state.importProgressSummary['pending'])} | {this.state.importProgressSummary['total']}</p>
                                                                    </>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    this.state.currentTab == 0 && this.state.csvData.length > 0 && this.state.validations['isHeadersValid'] && (
                                                        <button type="button" className="btn import-btn" onClick={() => {
                                                            this.setState({
                                                                currentTab: 1
                                                            })
                                                        }}>
                                                            Proceed
                                                        </button>
                                                    )
                                                }
                                                {
                                                    this.state.currentTab == 1 && (
                                                        <>
                                                            {
                                                                this.state.validations['isVerified'] ?
                                                                    <span className="d-flex align-items-center text-success-color font-size14 font-weight-bold">
                                                                        <FontAwesomeIcon icon={['fas', 'check-circle']} size={'md'} className="mx-1"></FontAwesomeIcon> Verified
                                                                    </span>
                                                                    :
                                                                    resultPendingData?.length > 0 || resultFailedData?.length > 0 ?
                                                                        this.state.loadingImportProcess ? <ButtonLoader /> :
                                                                            <button type="button" className="btn import-btn" disabled={this.state.validations['isVerified']}
                                                                                onClick={() => {

                                                                                    let importProgressSummary = { completed: 0, failed: 0, total: this.state.postInvoiceDetailsArray.length, pending: this.state.postInvoiceDetailsArray.length }
                                                                                    this.setState({
                                                                                        loadingImportProcess: true,
                                                                                        importProgressSummary
                                                                                    }, () => {

                                                                                        this.apiCallToImportVerifyInvoiceDetails(0, this.state.importProgressSummary)
                                                                                    })
                                                                                }

                                                                                }
                                                                            >
                                                                                Verify
                                                                            </button>

                                                                        : null

                                                            }

                                                            {/* (resultSuccessData?.length > 0 && (resultFailedData?.length == 0 || this.state.loadingImportProcess == false)) */}
                                                            {(resultSuccessData?.length > 0 && this.state.loadingImportProcess == false && resultFailedData?.length == 0) ?
                                                                this.state.loadingImportInvoiceProcess ? <ButtonLoader /> :
                                                                    < button type="button" className="btn import-btn" disabled={this.state.isImportButtonDisabled} onClick={() => {
                                                                        this.setState({
                                                                            loadingImportInvoiceProcess: true
                                                                        }, () => {
                                                                            this.apiCallToAddInvoiceDetails(0)
                                                                        })
                                                                    }
                                                                    }>
                                                                        Import
                                                                    </button>
                                                                : null
                                                            }

                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.importInvoiceModal && <div className="modal-backdrop fade show"></div>}
            </>
        )
    }

    // CHOOSE INVOICE COMPONENT
    chooseFileComponent = () => {
        return (
            <>
                <div className="import-info">
                    <div className="import-info-title ">
                        <p className="import-h5">Steps to import Invoice Details:</p>
                    </div>
                    <ol className="instruction-list mt-2 mb-2">
                        <li>Invoice Details can be imported in csv format.</li>
                        <li>CSV should be in specified format for import to work correctly.</li>
                        <li>
                            Refer the below example while adding content to the csv.  &nbsp;
                            <span className="download-links font-weight-bold" onClick={() => this.props.export()}>
                                Download Sample CSV File
                                &nbsp;<FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                            </span>
                            {this.props.csvLoading &&
                                <span> &nbsp;<FontAwesomeIcon icon={['fas', 'circle-notch']} size={'md'} className='rotate' style={{ color: '#0465AC' }} /></span>
                            }
                        </li>
                        <li>Refer the prerequire data to import.
                            <CSVLink
                                onFileLoaded={this.state.preRequisiteData}
                                data={this.state.preRequisiteData}
                                id='downloadPreRequisitePostEventDetails'
                                headers={this.state.preRequisiteHeaders}
                                filename={this.state.preRequisiteFileName}
                            >
                                <span
                                    className={`download-links font-weight-bold ${(!this.state.loadingPurchaseOrderData) ? 'download-links' : 'disabledLink'}`}
                                    onClick={(invoice) => {
                                        if (
                                            !this.state.loadingPurchaseOrderData
                                        ) {
                                            // Allow the download
                                            this.downloadPrerequisitedataCSV();
                                        } else {
                                            // Prevent the download
                                            invoice.preventDefault();
                                        }
                                    }}
                                >
                                    Download Prerequisite CSV File <FontAwesomeIcon icon={['fas', 'download']} size={'md'}></FontAwesomeIcon>
                                </span>
                            </CSVLink>
                        </li>
                    </ol>

                    <div className="import-info-preview">
                        {
                            this.state.csvData.length > 0 ? (
                                <div className="table-responsive" style={{ overflowY: 'auto', height: '250px' }}>
                                    <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                        <thead>
                                            {
                                                this.state.postInvoiceHeadersArray.map((item) => {
                                                    return (
                                                        <th>{item}</th>
                                                    )
                                                })
                                            }
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.postInvoiceDetailsArray.map((item, index) => {
                                                    if (item != undefined) {
                                                        return (
                                                            <tr>
                                                                {
                                                                    this.state.postInvoiceHeadersArray.map((keys) => {
                                                                        if (typeof item[keys] == 'object') {
                                                                            return <td>{item[keys]['value']}</td>
                                                                        } else {
                                                                            return <td>{item[keys]}</td>
                                                                        }
                                                                    })
                                                                }

                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            ) : <span className="initial-preview"><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon><p className="mx-2">After choosing file, You can view content here.</p></span>
                        }

                    </div>

                </div>
                <div className="import-info-note mt-2 mb-3">
                    <p>Once you dowload the sample CSV file. Update the neccessary content. In order to import the updated file you have to upload by clicking on the button mentioned below.</p>
                </div>
                <div className="import-body">
                    <div className="d-flex align-items-center flex-wrap">
                        <div style={{ display: "none" }}>
                            <CSVReader
                                cssClass="csv-reader-input"
                                label="Select CSV file"
                                onFileLoaded={this.handleCSVInput}
                                parserOptions={papaparseOptions}
                            />
                        </div>
                        <button type="button" className="btn import-btn" onClick={this.openFileInput}>
                            <FontAwesomeIcon icon={['fas', 'paperclip']} size={'lg'} color={"#FFF"}></FontAwesomeIcon> Choose File
                        </button>
                        {
                            Object.keys(this.state.selectedCSVFiles).length > 0 ?
                                <span>
                                    <span>
                                        {this.state.selectedCSVFiles['name']}
                                        <span style={{ "cursor": 'pointer' }} onClick={this.removeCSVFile}>
                                            <FontAwesomeIcon icon={['fas', 'times']} size={'md'}></FontAwesomeIcon>
                                        </span>
                                    </span>
                                </span>
                                : <p className="mb-0"><span className="text-danger">*</span> Please choose your csv file to import invoice details</p>
                        }
                    </div>
                </div>
                {
                    this.state.csvData.length > 0 && !this.state.validations['isHeadersValid'] &&
                    <div className="alert alert-danger" style={{ maxHeight: '20vh', overflow: "auto" }}>
                        {
                            Object.values(this.state.validations['headersErrors']).map((item) => {
                                return <p className="text-danger my-2">Header {item.cell}-{item.message}</p>
                            })
                        }
                    </div>
                }
            </>
        )
    }

    // IMPORT CSV FILE COMPONENT 
    importCSVFileComponent = () => {
        return (
            <>
                <div className="previw-sheet" style={{ minHeight: '40vh' }}>
                    {
                        this.state.csvData.length > 0 ? (
                            <div className="table-responsive" style={{ overflowY: 'auto', height: '250px' }}>
                                <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                                    <thead>
                                        <th className="td-dense">{"Sr. No."}</th>
                                        <th className="td-dense">{"Status"}</th>
                                        {/* {this.state.currentProgress == 0 ? "Error Location" : } */}
                                        {
                                            this.state.postInvoiceHeadersArray.map((item) => {
                                                return (
                                                    <th className="td-dense">
                                                        {item === 'Title' ? (
                                                            <>
                                                                {item} <span className="text-danger">*</span>
                                                            </>
                                                        ) : (
                                                            item
                                                        )}
                                                    </th>
                                                )
                                            })
                                        }
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.postInvoiceDetailsArray.map((item, index) => {

                                                if (item != undefined) {
                                                    return (

                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td className="td-dense">
                                                                {
                                                                    this.getCurrentStatusComponent(index, item['verificationStatus'], item['importStatus'])
                                                                }
                                                            </td>

                                                            {
                                                                this.state.postInvoiceHeadersArray.map((keys, cellIndex) => {
                                                                    // Determine if the row is disabled based on the status
                                                                    const isRowDisabled = item['importStatus'] === 'success';
                                                                    return (
                                                                        <td className={this.state.currentErrorObject['row'] == index ? "td-dense-highlight" : "td-dense"}>
                                                                            <div className={this.state.currentErrorObject['row'] == index ? "table-row-highlighter" : ""}>
                                                                                {keys == "Purchase Order Name" ?
                                                                                    <>
                                                                                        <select
                                                                                            id="series-selction"
                                                                                            value={item['purchaseOrderNameId']}
                                                                                            className="form-control"
                                                                                            onChange={(e) => {
                                                                                                this.getValueOfRowInputs(index, 'purchaseOrderNameId', +e.target.value, keys);
                                                                                            }}
                                                                                            disabled={isRowDisabled}
                                                                                        >
                                                                                            <option value="">Select Series</option>
                                                                                            {
                                                                                                Object.values(this.state.poData).map((series) =>
                                                                                                    (<option key={series.Uniqueid} value={series.Uniqueid}>{series.seriesTitle + series.seriesCounter}</option>)
                                                                                                )
                                                                                            }
                                                                                        </select>
                                                                                        <span class="text-danger">{item['purchaseOrderNameId'] ? null : "Invalid purchase order name"}</span>
                                                                                    </>
                                                                                    :
                                                                                    <input
                                                                                        type='text'
                                                                                        placeholder={`Enter ${keys}`}
                                                                                        value={item[keys]}
                                                                                        ref={(el) => this.tableObject[`${index}-${cellIndex}`] = el}
                                                                                        style={{ width: '200px' }} // Correct way to apply inline style as an object
                                                                                        className="form-control filterInput"
                                                                                        onChange={(e) => {
                                                                                            this.getValueOfRowInputs(index, keys, e.target.value, keys);
                                                                                        }}
                                                                                        disabled={isRowDisabled}
                                                                                    />}

                                                                            </div>
                                                                        </td>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    )
                                                }
                                            })
                                        }

                                    </tbody>
                                </table>
                            </div>
                        ) : <p>Data is not available.</p>
                    }
                </div>
                <p><span className="text-danger my-2 font-size14">*</span>Note : Errors are indicated by red boxes. Please click on the red boxes to correct them. </p>

                <div className="inspect-console">
                    <div className="table-responsive">
                        <table className="table table-bordered" style={{ backgroundColor: '#FFF' }}>
                            <thead>
                                <tr>
                                    <th rowSpan={2} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        <div className="import-progress">
                                            {
                                                this.state.importProgress.map((item, index) => {
                                                    return (
                                                        <div className="tab-wrapper">
                                                            <div className="step-wrapper">
                                                                <span className={this.state.currentProgress == index ? "circle-tab" : "circle-tab-muted"} style={this.checkImportTabProgress(index) ? { background: "green", color: "#FFF" } : {}}>{index + 1}</span>
                                                                {index < this.state.importProgress.length - 1 && <span className={this.state.validations['isVerified'] ? "step-line bg-success" : "step-line "}></span>}
                                                            </div>
                                                            <p className={this.state.currentProgress == index ? "mb-0 mx-2" : "mb-0 mx-2 text-muted"}>{item.name}</p>
                                                        </div>

                                                    )
                                                })
                                            }
                                        </div>
                                    </th>

                                    <th>
                                        <div className="d-flex justify-content-between align-items-center" >
                                            <span onClick={() => {
                                                this.state.currentPointer > 0 && this.navigateToPreviousError()
                                            }} disabled={true} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-left']} size="md"></FontAwesomeIcon></span>
                                            <p className="mb-0 font-weight-bold">Error Location :
                                                {Object.keys(this.state.currentErrorObject).length > 0 &&
                                                    `Rows : ${this.state.currentErrorObject['row'] + 1} Columns : ${this.state.currentErrorObject['key']}`
                                                }
                                            </p>
                                            <span onClick={() => {
                                                this.state.currentPointer < this.state.errorLogs.length && this.navigateToNextError()
                                            }} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'arrow-right']} size="md"></FontAwesomeIcon></span>
                                        </div>
                                    </th>
                                </tr>
                                <tr>

                                    <th align="center" style={{ verticalAlign: "middle", textAlign: "center" }}>
                                        {
                                            this.state.errorLogs.length > 0 ?
                                                (
                                                    <div>{this.ErrorViewConsole()}</div>
                                                )
                                                : <span className="initial-preview"><FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999"></FontAwesomeIcon><p className="mx-2 mb-0">After verification, You can view content which has errors.</p></span>
                                        }
                                        {/* 
										{
											this.state.errorMessageObjArray?.length > 0 ?
												this.state.errorMessageObjArray?.map((row) => {
													let rowIndex = row['rowIndex'];
													let message = row['message'];
													return <div>Row : {rowIndex} | Error : {message}</div>;
												})
												:
												<span className="initial-preview">
													<FontAwesomeIcon icon={['fas', 'database']} size={'lg'} color="#999" />
													<p className="mx-2 mb-0">After verification, You can view content which has errors.</p>
												</span>
										} */}

                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </>
        )
    }

    // 	GET CURRENT STATUS COMPONENT
    getCurrentStatusComponent = (index, verificationStatus = "pending", importStatus = "pending") => {
        {
            return this.state.importPointer['rowindex'] == index ?
                <div>
                    {
                        this.state.importPointer['loading'] ?
                            <div class="spinner-border spinner-border-sm" role="status" >
                                <span class="sr-only">{this.state.importPointer['status']}...</span>
                            </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div>{this.state.importPointer['status']}</div>
                                {/* {
                                    this.state.importPointer['status'] == 'failed' &&
                                    // importStatus == 'failed' &&
                                    <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                                        this.setState({
                                            loadingImportProcess: true
                                        }, () => {
                                            this.apiCallToImportVerifyInvoiceDetails(index, this.state.importProgressSummary, 'true')
                                        })
                                    }>
                                        Retry
                                    </button>
                                } */}
                            </div>

                    }

                </div>

                : <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div>{importStatus}</div>

                    {/* {
                        // this.state.importPointer['status'] == 'failed' &&
                        importStatus == 'failed' &&
                        <button type="button" className="btn import-btn" disabled={this.state.importProgressSummary['failed'] == 0} onClick={() =>
                            this.setState({
                                loadingImportProcess: true
                            }, () => {
                                this.apiCallToImportVerifyInvoiceDetails(index, this.state.importProgressSummary, 'true')
                            })
                        }>
                            Retry
                        </button>
                    } */}
                </div>
        }
    }

    //function to download prerequisite data 
    downloadPrerequisitedataCSV = () => {
        let preRequisiteData = this.state.preRequisiteCSVDataForFaculty
        let preRequisiteHeaders = this.state.preRequisiteCSVHeadersForFaculty


        // For purchaseOrderNameList
        if (Object.values(this.state.poData).length > 0) {
            Object.keys(this.state.poData).map((Id, index) => {
                let poName = this.state.poData[Id]
                // Concatenating seriesTitle and seriesCounter
                let concatenatedPoName = poName.seriesTitle + poName.seriesCounter;

                if (poName != undefined) {
                    if (preRequisiteData[index] != undefined) {
                        preRequisiteData[index].poName = concatenatedPoName
                    } else {
                        preRequisiteData.push({ poName: concatenatedPoName })
                    }
                }
            })
        }

        this.setState({
            preRequisiteData: preRequisiteData,
            preRequisiteHeaders: preRequisiteHeaders,
        })
    }
    // Strip HTML
    stripHtml(html) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    //FUNCTION DEFINED TO GET THE INPUT OF THE IMPORTED CSV
    handleCSVInput = (csvData, fileInformation) => {
        let poSeriesId = '';
        this.setState({
            selectedCSVFiles: fileInformation
        })

        if (fileInformation.type !== "text/csv") {
            this.setState({
                selectedCSVFiles: {},
                successModal: true,
                successModalType: "error",
                successMessage: "Please select csv file.",
                isValidAttachment: false
            })
        } else {
            let postInvoiceDetailsArray = [];
            let postInvoiceHeadersArray = [];

            if (csvData.length > 0) {
                csvData = csvData.filter((rowArray, index) => rowArray.length > 1 && !rowArray.every((val) => val == ""));

                // Read CSV Headers
                let headers = csvData[0];

                if (headers != undefined && headers.length > 0) {
                    headers.map((headerName, index) => {
                        if (headerName != undefined && headerName.trim() !== "") {
                            postInvoiceHeadersArray.push(headerName.trim());
                        }
                    })
                } else {
                    toast.warn("Invalid headers found in imported csv file.", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

                // Read CSV Actual Body Data
                if (postInvoiceHeadersArray.length > 0) {
                    csvData.map((csvRow, index) => {
                        if (index != 0) {
                            let invoiceObject = {};

                            for (let i = 0; i < postInvoiceHeadersArray.length; i++) {
                                if (csvRow[i] == undefined || csvRow[i] == null || csvRow[i] == "") {
                                    invoiceObject[postInvoiceHeadersArray[i]] = "";
                                } else {
                                    invoiceObject[postInvoiceHeadersArray[i]] = csvRow[i];
                                }
                            }

                            poSeriesId = invoiceObject['Purchase Order Name'] ?
                                (Object.values(this.state.poData).find(po => (po.seriesTitle + po.seriesCounter) === invoiceObject['Purchase Order Name'])?.Uniqueid || '')
                                : '';

                            invoiceObject['purchaseOrderNameId'] = poSeriesId;

                            postInvoiceDetailsArray.push({ ...invoiceObject, verificationStatus: "pending", importStatus: "pending", loading: false });
                        }
                    })
                }
            }

            this.setState({
                csvData: [...csvData],
                postInvoiceDetailsArray: postInvoiceDetailsArray,
                postInvoiceHeadersArray: postInvoiceHeadersArray
            }, () => {
                this.validateCSVFileHeaders();

            })
        }
    }

    // VALIDATE CSV FILE HEADERS
    validateCSVFileHeaders = () => {
        let commonHeaders = ["Purchase Order Name", "Bill Date*", "Bill Number*", "Amount*", "Note"]
        let mandatoryHeaders = ["Bill Date*", "Bill Number*", "Amount*"]
        let postInvoiceHeadersArray = this.state.postInvoiceHeadersArray;
        let validations = this.state.validations;

        if (postInvoiceHeadersArray.length > 0) {
            // Checking Default invoice Headers are available or not.
            mandatoryHeaders.map((header, index) => {
                if (!postInvoiceHeadersArray.includes(header)) {
                    let validationObject = {
                        touch: true,
                        cell: index + 1,
                        row: 0,
                        status: "error",
                        message: `${header} is mandatory column to import invoice.`,
                        type: "header",
                        errorCount: 0
                    }
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }
            })

            // Checking Dyanamic invoice Headers are available or not.
            postInvoiceHeadersArray.map((key, index) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    status: "error",
                    message: "",
                    type: "header",
                    errorCount: 0
                }

                let isValidHeader = commonHeaders.some((keys) => {
                    return keys == key.trim();
                })

                let validationMessage = '';
                if (key) {
                    validationMessage = ` ${key} header is invalid.`
                } else {
                    validationMessage = ` ${key} header is missing.`
                }

                if (!isValidHeader) {
                    validationObject.cell = index;
                    validationObject.status = "error";
                    validationObject.message = `Please check default headers. ${validationMessage}`;
                    validationObject.touch = true;
                }


                if (validationObject.touch) {
                    validations['headersErrors'].push(validationObject)
                    validations['isHeadersValid'] = false;
                }

            })
        }


        if (validations['headersErrors'].length == 0) {
            validations['isHeadersValid'] = true;
        }

        this.setState({
            validations: { ...validations }
        })
    }

    // VALIDATE CSV FILE DATA
    validateCSVFileData = () => {
        let postInvoiceDetailsArray = this.state.postInvoiceDetailsArray;
        let postInvoiceHeadersArray = this.state.postInvoiceHeadersArray;
        let validations = { ...this.state.validations, dataErrors: {}, errors: [], isDataValid: false, isVerified: false };
        let verificationSummary = {
            completed: 0,
            failed: 0,
            total: 0,
            pending: 0
        };

        verificationSummary['total'] = postInvoiceDetailsArray.length;
        verificationSummary['pending'] = postInvoiceDetailsArray.length;
        let verificationPointer = this.state.verificationPointer;

        postInvoiceDetailsArray.map((item, rowIndex) => {
            let status = true;
            let hasEarning = true;
            verificationPointer['loading'] = true;
            verificationPointer['status'] = 'verfying';
            verificationPointer['rowindex'] = rowIndex;
            this.setState({
                verificationPointer: verificationPointer
            })

            verificationSummary['pending'] -= verificationSummary['pending'];

            postInvoiceHeadersArray.map((key, cellIndex) => {
                let validationObject = {
                    touch: false,
                    cell: 0,
                    row: 0,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "",
                    type: "data",
                    errorCount: 0
                }

                if (validationObject.touch) {
                    status = false;
                    if (validations['dataErrors'][rowIndex] == undefined) {
                        validations['dataErrors'][rowIndex] = {};
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;

                    } else {
                        validations['dataErrors'][rowIndex][validationObject.cell] = validationObject;
                    }
                    item['verificationStatus'] = "failed";
                    validations['isDataValid'] = false;
                }
            })

            if (hasEarning) {
                validations['errors'].push({
                    touch: true,
                    cell: 0,
                    row: rowIndex,
                    key: "",
                    cellName: "",
                    status: "error",
                    message: "Please enter atleast one earning component",
                    type: "basic",
                    errorCount: 1
                })

                verificationPointer['status'] = 'failed';
                postInvoiceDetailsArray[rowIndex]['verificationStatus'] = 'failed';
                verificationPointer['loading'] = false;
            } else {
                verificationPointer['status'] = status ? 'verified' : 'failed';
                postInvoiceDetailsArray[rowIndex]['verificationStatus'] = verificationPointer['status'];
                verificationPointer['loading'] = false;
            }

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];

            this.setState({
                postInvoiceDetailsArray: [...postInvoiceDetailsArray],
                verificationProgress: verificationSummary,
                verificationPointer: verificationPointer,
            })
        })

        if (validations['errors'].length > 0) {
            let failedCount = 0;
            validations['errors'].map(item => {
                if (!Object.keys(validations['dataErrors']).includes(item.row)) {
                    failedCount++;
                }
            })

            verificationSummary['failed'] = Object.keys(validations['dataErrors']).length + failedCount;
            verificationSummary['completed'] = (verificationSummary['total'] - verificationSummary['pending']) - verificationSummary['failed'];
        }


        if (Object.keys(validations['dataErrors']).length == 0 && validations['errors'].length == 0) {
            validations['isDataValid'] = true;
            validations['isVerified'] = true;
            this.setState({
                currentPointer: 1
            })
        }

        this.setState({
            validations: { ...validations },
            verificationProgress: verificationSummary,
            loadingVerificationProcess: false
        }, () => {
            this.getBugLogs();
        })
    }

    // GET VALUES FORM INPUT FIELDS
    getValueOfRowInputs = (rowIndex, key, value, type) => {
        let postInvoiceDetailsArray = this.state.postInvoiceDetailsArray;
        let rowObject = postInvoiceDetailsArray[rowIndex];
        if (typeof rowObject[key] == 'object') {
            rowObject[key]['value'] = value;
        } else {
            rowObject[key] = value;
        }

        postInvoiceDetailsArray[rowIndex] = rowObject;

        this.setState({
            postInvoiceDetailsArray: postInvoiceDetailsArray
        })
    }

    // Navigate to previous 
    navigateToPreviousError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer > 0) {
            currentPointer -= 1;
            currentErrorObject = errorLogs[currentPointer];
            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }

    }

    // Navigate to next
    navigateToNextError = () => {
        let errorLogs = this.state.errorLogs;
        let currentPointer = this.state.currentPointer;
        let currentErrorObject = {};

        if (currentPointer < errorLogs.length - 1) {

            currentPointer += 1;
            currentErrorObject = errorLogs[currentPointer];

            this.setState({
                currentPointer: currentPointer,
                currentErrorObject: currentErrorObject
            }, () => {
                let { row, cell, key } = this.state.currentErrorObject;
            })
        }
    }

    // CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
            successModalType: "",
            successMessage: ""
        })
    }

    // CONSOLE ERROR 
    ErrorViewConsole = () => {
        let { row, message } = this.state.currentErrorObject;
        return (
            <div>
                {
                    this.state.currentErrorObject['key'] != "" && (
                        <div>
                            <p className="mb-0 font-weight-bold text-danger">{this.state.currentErrorObject['message']}</p>
                        </div>
                    )

                }
            </div>
        )
    }

    // API CALL TO IMPORT VERIFY INVOICE
    apiCallToImportVerifyInvoiceDetails = async (rowIndex = 0, importProgressSummary = { completed: 0, failed: 0, total: 0, pending: 0 }, isRetry = "") => {

        if (rowIndex < this.state.postInvoiceDetailsArray.length) {
            let invoiceData = this.state.postInvoiceDetailsArray[rowIndex];
            let importPointer = this.state.importPointer;
            importPointer['loading'] = true;
            importPointer['status'] = 'importing';
            importPointer['rowindex'] = rowIndex;
            this.setState({
                importPointer: importPointer,
            })

            let errorLogs = this.state.errorLogs;

            let purchaseOrderName = invoiceData['Purchase Order Name'] ? invoiceData['Purchase Order Name'].trim() : '';
            let billDate = invoiceData['Bill Date*'] ? invoiceData['Bill Date*'].trim() : '';
            let billNumber = invoiceData['Bill Number*'] ? invoiceData['Bill Number*'].trim() : '';
            let note = invoiceData['Note'] ? invoiceData['Note'].trim() : '';
            let totalAmount = invoiceData['Amount*'] ? invoiceData['Amount*'].trim() : '';

            let requestData = {
                "purchaseOrderName": purchaseOrderName,
                "iid": config.institute_id,
                "billDate": billDate,
                "billNumber": billNumber,
                "note": note,
                "totalAmount": totalAmount,
                "facultyId": config.faculty_id,
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'library_importInvoiceDetails',
                requestData,
                "/api/library/libraryInvoice.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToImportVerifyInvoiceDetails(rowIndex, importProgressSummary, isRetry);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    // set response
                    this.setState({
                        verifyImportInvoiceResult: apiResult
                    })
                    if (apiResult.status == 'success') {
                        let postInvoiceDetailsArray = this.state.postInvoiceDetailsArray;
                        let rowItem = postInvoiceDetailsArray[rowIndex];

                        rowItem['status'] = 'completed'
                        postInvoiceDetailsArray[rowIndex] = rowItem;

                        importProgressSummary['completed'] += 1;
                        if (isRetry != "true") {

                            importProgressSummary['pending'] -= 1;
                        } else {
                            importProgressSummary['failed'] -= 1;
                        }

                        importPointer['status'] = 'success';
                        postInvoiceDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;


                        let findIndex = errorLogs.findIndex(obj => obj.row == rowIndex)

                        if (findIndex != -1) {
                            errorLogs.splice(findIndex, 1);
                        }


                        this.setState({
                            postInvoiceDetailsArray: postInvoiceDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentPointer: 0,
                            currentErrorObject: errorLogs.length > 0 ? errorLogs[0] : {}
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportVerifyInvoiceDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                    else {
                        // let rowIndex = rowIndex + 1;
                        let errorObj = {};
                        errorObj['row'] = rowIndex;
                        errorObj['key'] = apiResult.key;
                        errorObj['message'] = apiResult.message;

                        // errorLogs.push(errorObj);

                        let foundIndex = errorLogs.findIndex(obj => obj.row == rowIndex);
                        if (foundIndex != -1) {
                            errorLogs[foundIndex] = errorObj;
                        }
                        else {
                            errorLogs.push(errorObj);
                        }

                        // currentErrorObject['rowIndex'] = rowIndex + 1;
                        // currentErrorObject['key'] = apiResult.key;
                        // currentErrorObject['message'] = apiResult.message;
                        let postInvoiceDetailsArray = this.state.postInvoiceDetailsArray;
                        let rowItem = postInvoiceDetailsArray[rowIndex];
                        rowItem['status'] = 'failed';
                        postInvoiceDetailsArray[rowIndex] = rowItem;
                        if (isRetry != "true") {
                            importProgressSummary['failed'] += 1;
                            importProgressSummary['pending'] -= 1;
                        }

                        importPointer['status'] = 'failed';

                        postInvoiceDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                        importPointer['loading'] = false;

                        this.setState({
                            postInvoiceDetailsArray: postInvoiceDetailsArray,
                            importProgressSummary: importProgressSummary,
                            importPointer: importPointer,
                            currentErrorObject: errorLogs[0],
                            currentPointer: 0,
                        }, () => {
                            if (isRetry != "true") {

                                this.apiCallToImportVerifyInvoiceDetails(rowIndex + 1, importProgressSummary, isRetry);
                            }
                        })

                    }
                }
                else {
                    let postInvoiceDetailsArray = this.state.postInvoiceDetailsArray;
                    importProgressSummary['failed'] += 1;
                    importPointer['status'] = 'failed';
                    postInvoiceDetailsArray[rowIndex]['importStatus'] = importPointer['status'];
                    importPointer['loading'] = false;

                    this.setState({
                        postInvoiceDetailsArray: postInvoiceDetailsArray,
                        importProgressSummary: importProgressSummary,
                        importPointer: importPointer,
                        currentPointer: 0,
                    }, () => {

                        if (isRetry != "true") {

                            this.apiCallToImportVerifyInvoiceDetails(rowIndex + 1, importProgressSummary, isRetry);
                        }
                    })

                }
            }

        } else {
            this.setState({
                loadingImportProcess: false
            })
        }
    }

    // API CALL TO IMPORT INVOICE DATA
    apiCallToAddInvoiceDetails = async (rowIndex = 0) => {

        if (rowIndex < this.state.postInvoiceDetailsArray.length) {
            let invoiceData = this.state.postInvoiceDetailsArray[rowIndex];
            this.state.vendorId = '';
            this.state.poId = '';

            let billDate = invoiceData['Bill Date*'];
            let billNumber = invoiceData['Bill Number*'];
            let invoiceNote = invoiceData['Note'] || '';
            let invoiceAmount = invoiceData['Amount*'];

            // Find the matching PO object where the seriesTitle matches data['Purchase Order Name']
            let matchingPO = Object.values(this.state.poData).find((poDetails) => {
                return poDetails.Uniqueid === invoiceData['purchaseOrderNameId'];
            });

            // If a matching PO is found, extract seriesId and vendorId
            if (matchingPO) {
                this.state.vendorId = matchingPO?.vendorId;
                this.state.poId = matchingPO?.Uniqueid;
            }

            let requestData = {
                "instituteId": config.institute_id,
                "vendorId": this.state.vendorId,
                "purchaseOrderId": this.state.poId,
                "billDate": billDate,
                "dueDate": "",
                "billNumber": billNumber,
                "note": invoiceNote,
                "linkTo": this.state.linkTo,
                "assetCategoryDetails": this.state.assetCategoryDetails,
                "facultyId": config.faculty_id,
                "taxType": this.state.taxType,
                "totalAmount": invoiceAmount,
                "academicYear": config.academicYear,
                "moduleName": "library"
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'accounting_addBill',
                requestData,
                "/api/accounting/accounting.php"
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.apiCallToAddInvoiceDetails(rowIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult;
                    if (apiResult.status == 'success') {
                        // toast.success(apiResult.message, {
                        //     position: "top-right",
                        //     autoClose: 2000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     progress: undefined,
                        // });
                        this.apiCallToAddInvoiceDetails(rowIndex + 1);
                        // this.setState({
                        //     successModal: true,
                        //     successModalType: 'success',
                        //     successMessage: apiResult.message
                        // }, () => {
                        //     this.apiCallToAddInvoiceDetails(rowIndex + 1);
                        // });
                    }
                    else {
                        toast.warn(apiResult.message, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        this.apiCallToAddInvoiceDetails(rowIndex + 1);
                        // this.setState({
                        //     successModal: true,
                        //     successModalType: 'warning',
                        //     successMessage: apiResult.message
                        // }, () => {
                        //     this.apiCallToAddInvoiceDetails(rowIndex + 1);
                        // });
                    }
                }
                else {
                    toast.error('Something went wrong while adding bill. Please try again later.', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.apiCallToAddInvoiceDetails(rowIndex + 1);
                    // this.setState({
                    //     successModal: true,
                    //     successModalType: 'error',
                    //     successMessage: 'Something went wrong while adding bill. Please try again later.'
                    // }, () => {
                    //     this.apiCallToAddInvoiceDetails(rowIndex + 1);
                    // });
                }
            }

        } else {
            this.setState({
                loadingImportInvoiceProcess: false,
                isImportButtonDisabled: true
            })
            // common success message
            toast.success("Invoice data imported successfully.", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    checkImportStatus = () => {
        return this.state.postInvoiceDetailsArray.some((item, index) => item.importStatus == 'success')
    }

    checkImportTabProgress = (index) => {
        if (index == 0) {
            return this.state.validations['isVerified']
        } else if (index == 1) {
            return this.checkImportStatus()
        }
    }

    render() {
        return (
            <>
                <button className="btn btn-outline-primary" title="Click here to import" type="button" id="expensesButton" disabled={this.state.isPurchaseOrderFetching} onClick={this.openImportInvoiceModal}>
                    {this.state.isPurchaseOrderFetching ?
                        <ButtonLoader />
                        : <>
                            <FontAwesomeIcon icon={['fas', "file-import"]} size="md" style={{ marginRight: 10 }} />Import
                        </>
                    }
                </button>

                {this.importInvoiceModal()}
                <div id="exportList"></div>
                <SuccessModal
                    successModal={this.state.successModal}
                    successModalType={this.state.successModalType}
                    successMessage={this.state.successMessage}
                    closeSuccessModal={this.closeSuccessModal}
                />

            </>
        )
    }
}

const ProgressBar = (props) => {
    const { bgcolor, completed, failed, pending, total } = props;

    let pendingProgressWidth = (pending / total) * 100;
    let completedProgressWidth = (completed / total) * 100;
    let failedProgressWidth = (failed / total) * 100;


    const containerStyles = {
        // height: 15,
        width: '100%',
        backgroundColor: "#e0e0de",
        margin: '0.2em 0',
        display: 'flex',

    }

    const fillerStyles = {
        height: '100%',
        borderRadius: 'inherit',
        textAlign: 'right',
        transition: 'width 1s ease-in-out',
    }

    const labelStyles = {
        padding: 5,
        color: 'white',
        fontWeight: 'bold',
        fontSize: '14px'
    }
    const completedProgress = {
        width: `${completedProgressWidth.toFixed(2)}%`,
        backgroundColor: 'green'
    }


    const failedProgress = {
        width: `${failedProgressWidth.toFixed(2)}%`,
        backgroundColor: 'tomato'
    }

    const pendingProgress = {
        width: `${pendingProgressWidth.toFixed(2)}%`,
        backgroundColor: 'orange'
    }
    return (
        <div style={containerStyles}>
            {
                total > 0 && (<>
                    <div style={{ ...fillerStyles, ...completedProgress }}>
                        <span style={labelStyles}>{`${completedProgressWidth.toFixed(2)}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...failedProgress }}>
                        <span style={labelStyles}>{`${failedProgressWidth.toFixed(2)}%`}</span>
                    </div>
                    <div style={{ ...fillerStyles, ...pendingProgress }}>
                        <span style={labelStyles}>{`${pendingProgressWidth.toFixed(2)}%`}</span>
                    </div>
                </>)
            }

        </div>
    );
};


const mapStateToProps = store => {
    return {
        // VARIABLES TO GET admin DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin
    };
};

export default connect(mapStateToProps)(ImportInvoice);